var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CreateTsoftChannel" } }, [
    _c(
      "div",
      { staticClass: "tsoft-container" },
      [
        _c(
          "div",
          { staticClass: "logo-container" },
          [_c("TsoftIcon", { staticClass: "tsoft-logo" })],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "a-form",
          { staticClass: "tsoft-form" },
          [
            _c(
              "a-form-item",
              [
                _c(
                  "a-input",
                  {
                    attrs: {
                      size: "large",
                      placeholder: "Domain adresinizi giriniz",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "domain", $$v)
                      },
                      expression: "form.domain",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "global" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c(
                  "a-input",
                  {
                    attrs: {
                      size: "large",
                      placeholder: "Kullanıcı adınızı giriniz",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.user,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "user", $$v)
                      },
                      expression: "form.user",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "user" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c(
                  "a-input-password",
                  {
                    attrs: {
                      size: "large",
                      placeholder: "Şifrenizi giriniz",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.pass,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pass", $$v)
                      },
                      expression: "form.pass",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "lock" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button-group" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "default", size: "large" },
                    on: { click: _vm.handleCancel },
                  },
                  [_vm._v("\n                    Vazgeç\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "large",
                      disabled: _vm.loading,
                    },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm.loading
                      ? [_c("a-spin")]
                      : [
                          _vm._v(
                            "\n                        Bağlan\n                    "
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-box" }, [
      _c("p", [
        _vm._v(
          "\n                Tsoft panel URL'niz üzerindeki\n                "
        ),
        _c("span", { staticClass: "highlight" }, [
          _vm._v("https://"),
          _c("span", { staticClass: "highlighted-part" }, [
            _vm._v("example-tsoft-biz"),
          ]),
          _vm._v(".tsoftpanel.com/"),
        ]),
        _vm._v(
          "\n                kısmını domain kısmına yazmanız gerekiyor.\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }